// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { getChildren } from '../../../../User/container/User.selectors';
import {
  getChildrenAction,
  removeChildAction,
  resetBirthdaySavingMessageAction,
  addChildAction,
} from './BirthdaySavingsList.actions';
import { getStatus, getMessage } from './BirthdaySavingsList.selectors';
import BirthdaySavingsComponent from '../views';
import { toastMessageInfo } from '../../../../../../common/atoms/Toast/container/Toast.actions';
import { BirthdaySavingsListSaga } from './BirthdaySavingsList.saga';
import BirthdaySavingsListReducer from './BirthdaySavingsList.reducer';
import GlobalErrorComponentReducer from '../../../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import { setGlobalError } from '../../../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import { getNewGlobalErrorMessage } from '../../../../../../../reduxStore/selectors/session.selectors';

/**
 * @function BirthdaySavings
 * @description Container component which will provide childrenBirthdays list to BirthdaySavingsList component
 */
export class BirthdaySavings extends PureComponent {
  static propTypes = {
    childrenBirthdays: PropTypes.shape([]).isRequired,
    getChildrenBirthdays: PropTypes.func.isRequired,
    resetBirthdaySavingMessage: PropTypes.func.isRequired,
  };

  /**
   * handle component mount
   */
  componentDidMount() {
    const { childrenBirthdays, getChildrenBirthdays } = this.props;
    if (!childrenBirthdays) {
      getChildrenBirthdays();
    }
  }

  componentWillUnmount() {
    const { resetBirthdaySavingMessage } = this.props;
    resetBirthdaySavingMessage();
  }

  componentDidUpdate(prevProps) {
    const { setGlobalErrorAction, status, message } = this.props;
    if (status !== prevProps.status) {
      setGlobalErrorAction({ message, type: status });
    }
  }

  /**
   * render BirthdaySavings list markup
   */
  render() {
    return <BirthdaySavingsComponent {...this.props} />;
  }
}

/**
 * @function mapStateToProps
 * @param { object } state
 * This function will return derived state props for BirthdaySavings component
 */
export const mapStateToProps = (state) => {
  return {
    childrenBirthdays: getChildren(state),
    status: getStatus(state),
    message: getMessage(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
  };
};

/**
 * @function mapDispatchToProps
 * @param { function } dispatch
 * This function will return dispatcher props for BirthdaySavings component
 */
export const mapDispatchToProps = (dispatch) => ({
  getChildrenBirthdays: () => {
    dispatch(getChildrenAction());
  },
  removeBirthday: (childId) => {
    dispatch(removeChildAction(childId));
  },
  addChildBirthday: (payload) => {
    dispatch(addChildAction(payload));
  },
  resetBirthdaySavingMessage: () => {
    dispatch(resetBirthdaySavingMessageAction());
  },
  toastMessage: (palyoad) => {
    dispatch(toastMessageInfo(palyoad));
  },
  setGlobalErrorAction: (payload) => {
    dispatch(setGlobalError(payload));
  },
});

const withReducer = withDynamicReducer([
  {
    key: 'BirthdaySavingsList',
    reducer: BirthdaySavingsListReducer,
  },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
]);
const withSaga = useDynamicSaga({ key: 'BirthdaySavingsSaga', saga: BirthdaySavingsListSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(BirthdaySavings);
